import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionFolderService } from '../../shared/services/index';
import { InspectionFolder } from '../../shared/models/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './new.component.html',
    standalone: false
})
export class NewFolderPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  sectionId: string;
  public processing = false;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private folderService: InspectionFolderService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['sectionId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.sectionId = pointId;

      this.initData();
    });
  }

  initData(): void {}

  create(folder: InspectionFolder): void {
    this.processing = true;
    this.folderService.createFolder(this.inspectionId, this.sectionId, { name: folder.name }).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel(): void {
    this.goToBack();
  }
}
